import Shepherd from 'shepherd.js'
import {highlightElStep, clickElStep} from './tours.js'

// Mention that their client clicked 'agree' to all of these.
export function reviewTourHook(tour) {
  let steps =
    [
      highlightElStep(tour, "Feedback/Check In Tour", "To help us improve the content, we'd love to hear more about each negative experiences", ".question-parent", "bottom"),
      highlightElStep(tour, "Feedback/Check In Tour", "Firstly, you can re-assign it to a colleague if you were incorrectly selected", ".select-user-role", "bottom"),
      highlightElStep(tour, "Feedback/Check In Tour", "Answering any of the questions is completely optional it will help us greatly!. When you're done, click the 'Complete' button at the bottom of the page", "#complete-form", "bottom"),
      highlightElStep(tour, "Rerunning this Tour", "You can rerun this tour later from your settings page.", "#my-settings-page", "bottom"),
      highlightElStep(tour, "All Done :)", "Thanks for your time! <br /> Your feedback helps us to understands the key issues in negative experiences. This summary data does not identify the vet or owner involved. We hope to use this data to improve our awareness campaign in the future.", ".question-parent", "bottom", true)
    ]

  tour.addSteps(steps);
  return {
    shouldRun() {
      return JSON.parse(this.el.dataset.should_run);
    },
    completeTour() {
      this.pushEvent("complete-review-tour", {})
    },
    startTour() {
      tour.start();
    },
    mounted() {
      if (this.shouldRun()) {
        this.startTour();
        tour.on("complete", _ => this.completeTour());
        tour.on("cancel", _ => this.completeTour());
      }
    }
  }
}
